export default __webpack_public_path__ + "static/maps-5ec58a247c9df46f73ee3777ee96bc41.png";